import React, { useEffect, useState } from 'react';
import DelightsTable from './DelightsTable';
import {
  Avatar,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Box } from '@mui/material';
import TabsFilter from '../components/DelightsData/TabsFilter';
import SearchBar from '../components/DelightsData/SearchBar';
import { useGetAllDelightsRequestsQuery, useUpdateHrRequestStatusMutation } from '../delightApiSlice';
import CustomDialogBox from '../../../common/CustomDialogBox';
import RequestDialog from '../components/DelightsData/RequestDialog';
import { DialogTitle } from '@mui/material';
import { Button } from '@mui/material';
import TabsFilterHR from './TabsFilterHR';
import toast from 'react-hot-toast';
import SkeletonTable from '../../RnR/AdminRnR/SkeletonTable';
import linkwaylogo from '../../../assets/Linkway/LinkwayLogo.png';
import GNXTLogo from '../../../assets/GatewayLogo/G_NXTLogo.png';
import { useTheme } from '@emotion/react';
import { useNavigate } from 'react-router-dom';

const HrDelights = () => {
  const { data, isLoading, isError, error } = useGetAllDelightsRequestsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [updateHrRequestStatus] = useUpdateHrRequestStatusMutation();
  const [rejectionReason, setRejectionReason] = useState('');
  const [openRejectionDialog, setOpenRejectionDialog] = useState(false);
  const navigate = useNavigate()

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));

  const handleShowDetails = (request) => {
    setSelectedRequest(request);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedRequest(null);
    setOpenDialog(false);
    // window.location.reload();  
  };

  const handleUpdateStatus = async (requestId, type, hrRejectionReason) => {
    try {
      if ((type === 'reject' && hrRejectionReason.trim() !== '') || type === 'approve') {
        const response = await updateHrRequestStatus({ requestId, hrRejectionReason }).unwrap();
        toast.success('Request status updated successfully');
        setRejectionReason('');
        setOpenDialog(false);
        setSelectedRequest(null);
        setOpenRejectionDialog(false);
      } else {
        toast.error('Please Fill Rejection Reason');
      }
    } catch (error) {
      console.log(error, 'ERROR');
    }
  };

  const handleRejectionClick = () => {
    setOpenRejectionDialog(true);
  };

  // if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const filteredData = data?.filter((request) => {
    const statusMatches =
      tabValue === 0 || request.hrStatus?.toLowerCase() === ['pending', 'approved', 'rejected'][tabValue - 1];
    const searchTextMatches =
      searchText === '' ||
      request.outingType?.toLowerCase().includes(searchText.toLowerCase()) ||
      request.numberOfMembers?.toString().includes(searchText) ||
      new Date(request.dateRequested).toLocaleDateString().includes(searchText) ||
      request.hrStatus?.toLowerCase().includes(searchText.toLowerCase()) ||
      request.requestedBy?.toLowerCase().includes(searchText.toLowerCase()) ||
      request.requestType?.toLowerCase().includes(searchText.toLowerCase());

    return statusMatches && searchTextMatches;
  });

  return (
    <>
      <Grid
        item
        xs={12}
        sx={{
          backgroundColor: 'white',
          borderRadius: '10px',
          border: 1,
          borderColor: 'divider',
          height: '100%',
          // height: 'calc(100vh - 135px)',
          overflow: 'hidden',
        }}
      >
        {isLoading ? (
          isSm ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '70vh',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.5)', // Adjust the transparency level
                backdropFilter: 'blur(5px)', // Optional: Adds a blur effect to the background
              }}
            >
              {/* <Avatar variant={'rounded'} src={GNXTLogo} sx={{ height: 50, width: 50 }} /> */}
              <img src={GNXTLogo} style={{ height: 70, width: 150 }} />
              <Typography sx={{ mt: 2 }}>Loading...</Typography>
            </Box>
          ) : (
            <SkeletonTable />
          )
        ) : (
          <Box
            sx={{
              borderRadius: '10px',
              '& .MuiTableCell-footer': {
                p: 0,
                border: 0,
              },
            }}
          >
            <TabsFilterHR tabValue={tabValue} setTabValue={setTabValue} data={data} />
            <SearchBar searchText={searchText} setSearchText={setSearchText} />
            <DelightsTable data={filteredData} handleShowDetails={handleShowDetails} />
          </Box>
        )}
      </Grid>
      {selectedRequest && (
        <CustomDialogBox
          fullScreen={'fullScreen'}
          height={'100%'}
          width="60%"
          open={openDialog}
          handleClose={handleCloseDialog}
          title="Details"
          disabled={selectedRequest.hrStatus !== 'Pending'}
          content={<RequestDialog selectedRequest={selectedRequest} isHr={true} />}
          actions={[
            {
              label: 'Approve',
              onClick: () => handleUpdateStatus(selectedRequest?._id, 'approve', ''),
            },
            {
              label: 'Reject',
              onClick: handleRejectionClick, // Open rejection dialog
            },
          ]}
        />
      )}
      <Dialog open={openRejectionDialog} onClose={() => setOpenRejectionDialog(false)}>
        <DialogTitle>Reject Request</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Rejection Reason"
            type="text"
            fullWidth
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            required
          />
        </DialogContent>
        <DialogActions>
          <Button
            {...(openRejectionDialog && { className: 'backButton' })}
            onClick={() => setOpenRejectionDialog(false)}
            color="primary"
          >
            Cancel
          </Button>
          <Button onClick={() => handleUpdateStatus(selectedRequest?._id, 'reject', rejectionReason)} color="primary">
            Reject
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default HrDelights;
